var _path, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeskPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,60.75h5.25V64A4.7554,4.7554,0,0,0,22,68.75H36A4.7554,4.7554,0,0,0,40.75,64V60.75H68A2.7528,2.7528,0,0,0,70.75,58V22A2.7528,2.7528,0,0,0,68,19.25H32A2.7528,2.7528,0,0,0,29.25,22V58A2.7528,2.7528,0,0,0,32,60.75h7.25V64A3.25377,3.25377,0,0,1,36,67.25H22A3.25377,3.25377,0,0,1,18.75,64V60.75H24A2.7528,2.7528,0,0,0,26.75,58V22A2.7528,2.7528,0,0,0,24,19.25H12A2.7528,2.7528,0,0,0,9.25,22V58A2.7528,2.7528,0,0,0,12,60.75Zm52.75-40H68A1.25116,1.25116,0,0,1,69.25,22V35.25h-4.5Zm-28,0h26.5v14.5H36.75Zm-6,1.25A1.25116,1.25116,0,0,1,32,20.75h3.25v14.5h-4.5ZM32,59.25A1.25116,1.25116,0,0,1,30.75,58V36.75h38.5V58A1.25116,1.25116,0,0,1,68,59.25ZM10.75,22A1.25116,1.25116,0,0,1,12,20.75H24A1.25116,1.25116,0,0,1,25.25,22V58A1.25116,1.25116,0,0,1,24,59.25H12A1.25116,1.25116,0,0,1,10.75,58Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 41.25,
    width: 6,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 47.25,
    width: 6,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 53.25,
    width: 6,
    height: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 42,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 42,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 42,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 48,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 48,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 48,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 54,
    r: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 54,
    r: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 54,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeskPhone);
export default __webpack_public_path__ + "static/media/icon_desk_phone.7c7bc24f4be17b530dd6446047875b43.svg";
export { ForwardRef as ReactComponent };